import { createTheme, Indicator, type MantineTheme } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineIndicator: PartialDeep<MantineTheme> = createTheme({
  components: {
    Indicator: Indicator.extend({
      defaultProps: {
        color: 'coral',
      },
    }),
  },
});
